import React, { useState } from "react";
import styled from 'styled-components';
import { getColor} from '@process-advisor/process-miner/shared/theme';
import { Event } from '@process-advisor/process-miner/api/events';
import { useApiListener } from '@process-advisor/process-miner/shared/hooks/useApiListener';
import * as processMiner from '@process-advisor/process-miner/processMiner/processMiner'
import { ProcessMinerGauges } from '@process-advisor/process-miner/navigation/topBar/processMinerGauges'
import { FindingDetails } from '@process-advisor/process-miner/findings/findingDetails'

const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 400px;
    height: 100%;
    background-color: ${getColor('white')};
    padding-top: 10px;
    padding-bottom: 10px;
`;
const Gauges = styled.div`
    margin-left: 50px;
`;


export const DownloadFinding = () => {
    const [findingID, setFindingID] = useState('');
    const [finding, setFinding] = useState('');
    const [filterSummary, setFilterSummary] = useState('');

    useApiListener(
        Event.downloadFinding,
        ({ findingID , finding, filterSummary}) => {
           setFindingID(findingID)
           setFinding(finding)
           setFilterSummary(filterSummary)
           if (typeof processMiner.downloadFinding === 'function') {
               processMiner.downloadFinding(findingID)
           }
        }
    );

    useApiListener(
        Event.updateFindingDetail,
        ({ findingID , finding, filterSummary}) => {
           setFindingID(findingID)
           setFinding(finding)
           setFilterSummary(filterSummary)
        }
    );

    return (
        <div >
            <div id="#findingDetails" >
                 <FindingDetails finding={finding} filterSummary={filterSummary} />
            </div>
            <div id="#gauges">
                <Gauges>
                    <ProcessMinerGauges/>
                </Gauges>
            </div>
        </div>
    );
};

